import Icon from "@/theme/component/utils/svg/Icon";
import Icon2 from "@/theme/component/utils/svg/Icon2";
import Icon3 from "@/theme/component/utils/svg/Icon3";
import Icon4 from "@/theme/component/utils/svg/Icon4";

export const milletsData = [
  {
    id: 1,
    img: "/assets/hindustanpurefoods/products/kutki-image-2.webp",
    subTitle: "Kutki Millet",
    title: "Panicum Sumatrense",
    slug: "kutki-millet",
    productDetails: {
      title: "A Nutritious and Sustainable Superfood",
      scientificName: "Panicum sumatrense",
      description:
        "Kutki Millet, also referred to as Little Millet or Samai in various regions, is a small-grained millet widely cultivated in India and South Asia. Its impressive nutritional profile, health benefits, and sustainability make it an excellent addition to a healthy diet.",
      conclusion:
        "Kutki millet (Little Millet) is a highly nutritious and sustainable grain, offering numerous health benefits such as improved digestion, weight management, and heart health. As a gluten-free alternative to rice and wheat, it is an excellent choice for health-conscious individuals looking to incorporate more whole grains into their diet. Its ability to thrive in harsh climates and low-resource farming makes it a valuable crop for sustainable agriculture.",
      names: [" Little millet", "Samai"],
    },

    recipe: [
      {
        imgMain:
          "/assets/hindustanpurefoods/product-details/kutki-khichdi.webp",
        imgIcon: "/assets/img/services/home-6-service-icon-1.png",
        title: "Kutki Millet Khichdi",
        steps: [
          "Rinse 1 cup Kutki millet and ½ cup moong dal.",
          "Sauté cumin, mustard seeds, and curry leaves in oil.",
          "Add chopped veggies, millet, dal, spices, and 3 cups water.",
          "Pressure cook for 3 whistles and serve hot.",
        ],
      },
      {
        imgMain: "/assets/hindustanpurefoods/product-details/kutki-pulao.webp",
        imgIcon: "/assets/img/services/home-6-service-icon-2.png",
        title: "Kutki Millet Pulao",
        steps: [
          "Rinse 1 cup Kutki millet and soak for 15 minutes.",
          "Sauté bay leaf, cumin, onions, and mixed veggies in oil.",
          "Add millet, salt, and 2 cups water, then cook covered.",
          "Fluff and serve with yogurt or chutney.",
        ],
      },
      {
        imgMain: "/assets/hindustanpurefoods/product-details/kutki-dosa.webp",
        imgIcon: "/assets/img/services/home-6-service-icon-3.png",
        title: "Kutki Millet Dosa",
        steps: [
          "Soak 1 cup Kutki millet, ½ cup urad dal, and 2 tbsp rice for 6 hours.",
          "Grind to a smooth batter and ferment overnight.",
          "Add salt, mix well, and spread on a hot tawa.",
          "Cook until golden and serve with chutney.",
        ],
      },
    ],

    features: [
      {
        title: "1. Size and Appearance",
        details: [
          {
            label: "~ Grain Characteristics:",
            value: "Small, round, and typically white or off-white in color.",
          },
          {
            label: "Comparison:",
            value:
              "Smaller than other millets like Pearl Millet or Finger Millet.",
          },
        ],
      },
      {
        title: "2. Nutritional Benefits",
        details: [
          {
            label: "High in Fiber:",
            value: "Promotes digestion and helps manage blood sugar levels.",
          },
          {
            label: "Rich in Protein:",
            value: "Provides a good source of plant-based protein.",
          },
          {
            label: "Low Glycemic Index:",
            value: "Beneficial for individuals with diabetes.",
          },
          {
            label: "Mineral-Rich:",
            value:
              "Contains calcium, iron, magnesium, and phosphorus, essential for bone health and metabolism.",
          },
        ],
      },
    ],
    healthBenefits: [
      {
        title: "Health Benefits",
        details: [
          {
            label: "Weight Management:",
            value: "Promotes digestion and helps manage blood sugar levels.",
          },
          {
            label: "Digestive Health:",
            value: "Provides a good source of plant-based protein.",
          },
          {
            label: "Heart Health:",
            value: "Beneficial for individuals with diabetes.",
          },
        ],
      },
    ],
    culinaryUses: [
      {
        title: "Culinary Uses",
        subTitle:
          "Kutki millet is versatile and can be used in a variety of dishes:",
        details: [
          {
            label: "Porridges and Upmas:",
            value: "Promotes digestion and helps manage blood sugar levels.",
          },
          {
            label: "Flour:",
            value: "Provides a good source of plant-based protein.",
          },
          {
            label: "Grain Salads and Pilafs:",
            value: "Beneficial for individuals with diabetes.",
          },
        ],
      },
    ],
    environmentalBenefits: [
      {
        title: "Environmental Benefits",
        details: [
          {
            label: "Drought-Resistant:",
            value: "Promotes digestion and helps manage blood sugar levels.",
          },
          {
            label: "Sustainable Crop:",
            value: "Provides a good source of plant-based protein.",
          },
        ],
      },
    ],
    rightImage:
      "/assets/hindustanpurefoods/product-details/kutki-millet-right.webp",
    bottomImages: [
      {
        img: "/assets/hindustanpurefoods/product-details/bottom-image-1.webp",
      },
      {
        img: "/assets/hindustanpurefoods/product-details/bottom-image-2.webp",
      },
      {
        img: "/assets/hindustanpurefoods/product-details/bottom-image-3.webp",
      },
    ],
  },
  {
    id: 2,
    img: "/assets/hindustanpurefoods/products/kodo-image-1.webp",
    subTitle: "Kodo Millet",
    title: "Paspalum scrobiculatum",
    slug: "kodo-millet",
    productDetails: {
      title: " A Nutritious and Sustainable Grain",
      scientificName: " Paspalum scrobiculatum",
      description:
        "Varan millet, also referred to as gurji or kodra in various regions, is a small-grain millet widely cultivated in India and parts of Asia and Africa. Its nutritional value and health benefits have made it increasingly popular as a sustainable and wholesome food choice.",
      conclusion:
        "Varan millet (Kodo millet) is a nutrient-dense, versatile grain offering numerous health benefits, particularly for digestive health, heart health, and weight management. Its ability to thrive in harsh climates and low resource requirements make it an environmentally sustainable and culturally significant crop. Whether used as a grain, flour, or ingredient in various dishes, Kodo millet is a wholesome addition to a healthy diet",
      names: ["Gurji", "Kodra"],
    },
    recipe: [
      {
        imgMain: "/assets/hindustanpurefoods/product-details/kodo-khichdi.webp",
        imgIcon: "kodo-icon.png",
        title: "Kodo Millet Khichdi",
        steps: [
          "Rinse 1 cup Kodo millet and ½ cup moong dal.",
          "Sauté cumin, mustard seeds, and curry leaves in oil.",
          "Add chopped veggies, millet, dal, spices, and 3 cups water.",
          "Pressure cook for 3 whistles and serve hot.",
        ],
      },
      {
        imgMain: "/assets/hindustanpurefoods/product-details/kodo-upma.webp",
        imgIcon: "foxtail-icon.png",
        title: "Kodo Millet Upma",
        steps: [
          "Dry roast 1 cup Foxtail millet and keep aside.",
          "Heat oil, sauté mustard seeds, curry leaves, ginger, and chilies.",
          "Add chopped veggies and cook for 2 minutes.",
          "Add 2.5 cups water, bring to a boil, then add millet and cook till soft.",
        ],
      },
      {
        imgMain: "/assets/hindustanpurefoods/product-details/kodo-dosa.webp",
        imgIcon: "barnyard-icon.png",
        title: "Kodo Millet Dosa",
        steps: [
          "Soak 1 cup Kodo millet, ½ cup urad dal, and 2 tbsp rice for 6 hours.",
          "Grind to a smooth batter and ferment overnight.",
          "Add salt, mix well, and spread on a hot tawa.",
          "Cook until golden and serve with chutney.",
        ],
      },
    ],
    features: [
      {
        title: "1. Appearance and Size",
        details: [
          {
            label: "Grain Characteristics:",
            value: "Small, oval-shaped grains with a slightly rough texture.",
          },
          {
            label: "Color:",
            value: " Varies from pale yellow to light brown.",
          },
        ],
      },
      {
        title: "2. Nutritional Benefits",
        details: [
          {
            label: "High in Fiber:",
            value: "Supports digestion and improves bowel movements.",
          },
          {
            label: "Rich in Protein:",
            value: "A great source of plant-based protein.",
          },
          {
            label: "Mineral-Rich:",
            value:
              " Contains essential minerals like iron, magnesium, phosphorus, and calcium.",
          },
          {
            label: "Low Glycemic Index:",
            value:
              "Helps regulate blood sugar levels, suitable for individuals with diabetes.",
          },
          {
            label: "Antioxidants:",
            value:
              "Fights oxidative stress and reduces the risk of chronic diseases.",
          },
        ],
      },
    ],
    healthBenefits: [
      {
        title: "Health Benefits",
        details: [
          {
            label: "Promotes Heart Health:",
            value:
              "Lowers bad cholesterol (LDL) and improves cardiovascular health.",
          },
          {
            label: "Aids Digestion:",
            value:
              "High fiber content prevents constipation and maintains digestive health.",
          },
          {
            label: "Supports Weight Management:",
            value:
              "Low in calories and high in fiber, helping in weight control.",
          },
          {
            label: "Strengthens Bones:",
            value:
              "Calcium and phosphorus contribute to bone health and prevent bone-related disorders.",
          },
        ],
      },
    ],
    culinaryUses: [
      {
        title: "Culinary Uses",
        subTitle: "Kodo millet can be used in a variety of dishes:",
        details: [
          {
            label: "As a Whole Grain:",
            value: "Cooked like rice or used in pilafs and salads.",
          },
          {
            label: "Millet Flour:",
            value:
              "Ground into flour to make gluten-free bread, rotis, or pancakes.",
          },
          {
            label: "Porridges:",
            value: " Ideal for breakfast porridges or savory dishes like upma.",
          },
          {
            label: "Snacks and Desserts:",
            value:
              "Used in energy bars, millet-based sweets, and healthy snacks.",
          },
        ],
      },
    ],
    environmentalBenefits: [
      {
        title: "Environmental Benefits",
        details: [
          {
            label: "Drought-Resistant:",
            value:
              "Thrives in arid conditions with minimal water, ideal for water-scarce regions.",
          },
          {
            label: "Sustainable Farming:",
            value:
              "Requires fewer chemical inputs, reducing its environmental impact.",
          },
        ],
      },
    ],
    culturalImportance: [
      {
        title: "Cultural Importance",
        details: [
          {
            label: "Staple Food:",
            value:
              "Traditionally consumed in rural India and other parts of Asia for centuries.",
          },
          {
            label: "Sustainable Choice:",
            value:
              "Valued for its adaptability to less fertile soils and irregular rainfall.",
          },
        ],
      },
    ],
    rightImage:
      "/assets/hindustanpurefoods/product-details/kutki-millet-right.webp",
    bottomImages: [
      {
        img: "/assets/hindustanpurefoods/product-details/bottom-image-1.webp",
      },
      {
        img: "/assets/hindustanpurefoods/product-details/bottom-image-2.webp",
      },
      {
        img: "/assets/hindustanpurefoods/product-details/bottom-image-3.webp",
      },
    ],
  },
  {
    id: 3,
    img: "/assets/hindustanpurefoods/products/banyard-image-1.webp",
    subTitle: "Barnyard Millet",
    title: "Echinochloa Frumentacea",
    slug: "barnyard-millet",
    productDetails: {
      title: "A Nutritious and Sustainable Grain",
      scientificName: "Echinochloa Frumentacea",
      description:
        "Barnyard millet also referred to as varai ,sanwa or oodalu in various regions, is a small, fast-growing cereal grain from the Poaceae family, commonly known as the grass family. It is a hardy crop capable of thriving in various soil types, including dry and arid conditions, and is widely cultivated in Asia (especially India, China, and Japan) and parts of Africa.",
      conclusion:
        "Barnyard millet is a versatile, nutritious, and sustainable grain gaining popularity worldwide. Its gluten-free nature, numerous health benefits, and adaptability to challenging agricultural conditions make it an excellent choice for health-conscious consumers and environmentally sustainable farming practices.",
      names: ["Varai", "Sanwa", "Oodalu"],
    },
    recipe: [
      {
        imgMain:
          "/assets/hindustanpurefoods/product-details/barnyard-khichdi.webp",
        imgIcon: "kodo-icon.png",
        title: "Barnyard Millet Khichdi",
        steps: [
          "Rinse 1 cup Barnyard millet and soak for 15 minutes.",
          "Sauté bay leaf, cumin, onions, and mixed veggies in oil.",
          "Add millet, salt, and 2 cups water, then cook covered.",
          "Fluff and serve with raita or chutney.",
        ],
      },
      {
        imgMain:
          "/assets/hindustanpurefoods/product-details/barnyard-dosa.webp",
        imgIcon: "foxtail-icon.png",
        title: "Barnyard Millet Dosa",
        steps: [
          "Rinse 1 cup barnyard millet and ¼ cup urad dal, then soak for 4-6 hours.",
          "Grind into a smooth batter, adding water as needed.",
          "Add salt and let it ferment overnight.",
          "Heat a tawa (griddle) and pour a ladle of batter, spreading it thin.",
          "Drizzle a little oil and cook until golden brown.",
          "Flip if needed, then serve hot with chutney or sambar.",
        ],
      },
      {
        imgMain:
          "/assets/hindustanpurefoods/product-details/barnyard-pulao.webp",
        imgIcon: "barnyard-icon.png",
        title: "Barnyard Millet Pulao",
        steps: [
          "Rinse 1 cup Barnyard millet and soak for 15 minutes.",
          "Sauté bay leaf, cumin, onions, and mixed veggies in oil.",
          "Add millet, salt, and 2 cups water, then cook covered.",
          "Fluff and serve with raita or chutney.",
        ],
      },
    ],
    features: [
      {
        title: "1. Size and Shape",
        details: [
          {
            label: "",
            value: "Small, round seeds that are white or pale yellow.",
          },
          {
            label: "",
            value: "The plant grows to a height of 1–2 meters.",
          },
        ],
      },
      {
        title: "2. Nutritional Value",
        details: [
          {
            label: "",
            value:
              "Rich in protein, fiber, and micronutrients such as calcium, iron, and B vitamins.",
          },
          {
            label: "",
            value:
              "Gluten-free, making it suitable for people with gluten sensitivities or celiac disease.",
          },
        ],
      },
    ],
    healthBenefits: [
      {
        title: "Health Benefits",
        details: [
          {
            label: "Rich in Fiber:",
            value: "Promotes digestive health and supports a healthy gut.",
          },
          {
            label: "Blood Sugar Control:",
            value:
              "Its low glycemic index helps regulate blood sugar levels, ideal for people with diabetes.",
          },
          {
            label: "High in Antioxidants:",
            value:
              "Contains antioxidant properties that combat oxidative stress in the body.",
          },
        ],
      },
    ],
    culinaryUses: [
      {
        title: "Culinary Uses",
        subTitle: "Culinary Applications:",
        details: [
          {
            label: "",
            value: "Cooked as porridge, pilaf, salad, or soup.",
          },
          {
            label: "",
            value:
              "Ground into flour for baking or making traditional flatbreads.",
          },
          {
            label: "",
            value: "Fermented in some regions to produce beverages.",
          },
        ],
      },
    ],
    environmentalBenefits: [
      {
        title: "Environmental and Sustainability Aspects",
        details: [
          {
            label: "",
            value: "Eco-friendly crop requiring less water than rice or wheat.",
          },
          {
            label: "",
            value:
              "Thrives with minimal irrigation, supporting sustainable agriculture in water-scarce areas.",
          },
        ],
      },
    ],
    culturalImportance: [
      {
        title: "Agricultural Importance",
        details: [
          {
            label: "",
            value:
              "Thrives in less-than-ideal conditions, such as drought or poor soil quality.",
          },
          {
            label: "",
            value:
              "Requires minimal irrigation, making it a reliable crop for regions with water scarcity.",
          },
        ],
      },
    ],
    rightImage:
      "/assets/hindustanpurefoods/product-details/kutki-millet-right.webp",
    bottomImages: [
      {
        img: "/assets/hindustanpurefoods/product-details/bottom-image-1.webp",
      },
      {
        img: "/assets/hindustanpurefoods/product-details/bottom-image-2.webp",
      },
      {
        img: "/assets/hindustanpurefoods/product-details/bottom-image-3.webp",
      },
    ],
  },
  {
    id: 4,
    img: "/assets/hindustanpurefoods/products/foxtail-image-2.webp",
    subTitle: "Foxtail Millet",
    title: "Setaria Italica",
    slug: "foxtail-millet",
    productDetails: {
      title: "A Nutritious and Sustainable Superfood",
      scientificName: "Setaria italica",
      description:
        "Foxtail millet also referred to as kangni or navane in various regions, is one of the oldest and most widely cultivated millets, especially in Asia and Africa. Known for its small, yellow or reddish grains, this millet is highly nutritious, versatile, and environmentally sustainable.",
      versatility:
        "Foxtail millet's excellent nutritional profile and versatility make it a popular choice for health-conscious individuals, athletes, and those seeking gluten-free alternatives.",
      conclusion:
        "Foxtail millet is a highly nutritious and sustainable grain offering numerous health benefits, such as improved digestion, blood sugar regulation, heart health, and weight management. Its adaptability to dry conditions and low resource requirements make it a valuable crop for water-scarce regions. Whether used as a grain, flour, or ingredient in various dishes, foxtail millet is a wonderful addition to a healthy and balanced diet.",
      names: ["Kangni", "Navane"],
    },
    recipe: [
      {
        imgMain: "/assets/hindustanpurefoods/product-details/foxtail-upma.webp",
        imgIcon: "kodo-icon.png",
        title: "Foxtail Millet Upma",
        steps: [
          "Dry roast 1 cup Foxtail millet and set aside.",
          "Sauté mustard seeds, curry leaves, onions, and chilies in oil.",
          "Add chopped veggies and cook for 2 minutes.",
          "Add 2.5 cups water, bring to a boil, then add millet and cook till soft.",
        ],
      },
      {
        imgMain:
          "/assets/hindustanpurefoods/product-details/foxtail-porridge.webp",
        imgIcon: "foxtail-icon.png",
        title: "Foxtail Millet Porridge",
        steps: [
          "Rinse ½ cup foxtail millet thoroughly and soak for 30 minutes.",
          "In a pot, heat 2 cups water and 1 cup milk.",
          "Add the soaked millet and cook on low heat until soft.",
          "Add salt, grated ginger, and a pinch of turmeric (optional).",
          "Stir well and simmer until it reaches a porridge consistency.",
          "Garnish with coriander leaves or nuts and serve warm.",
        ],
      },
      {
        imgMain: "/assets/hindustanpurefoods/product-details/foxtail-roti.webp",
        imgIcon: "barnyard-icon.png",
        title: "Foxtail Millet Roti ",
        steps: [
          "Take 1 cup foxtail millet flour in a mixing bowl.",
          "Add a pinch of salt and mix well.",
          "Gradually add warm water and knead into a soft dough.",
          "Divide the dough into small balls and roll each into a thin roti.",
          "Heat a tawa (griddle) and cook the roti on medium heat, flipping until golden brown.",
          "Apply ghee (optional) and serve hot with curry or chutney.",
        ],
      },
    ],
    features: [
      {
        title: "1. Appearance and Characteristics",
        details: [
          {
            label: "Grain Size and Shape:",
            value:
              "Small, oval grains, typically yellow, orange, or reddish in color.",
          },
          {
            label: "Plant Structure:",
            value:
              "Features bushy, feathery seed heads resembling a 'foxtail.'",
          },
          {
            label: "Texture and Flavor:",
            value:
              "Tender grains with a slightly nutty flavor and light, fluffy texture when cooked.",
          },
        ],
      },
      {
        title: "2. Nutritional Benefits",
        details: [
          {
            label: "High in Fiber:",
            value:
              "Promotes digestion, controls blood sugar, and supports heart health.",
          },
          {
            label: "Good Source of Protein:",
            value: "Plant-based protein suitable for vegetarians and vegans.",
          },
          {
            label: "Rich in Vitamins and Minerals:",
            value:
              "Contains iron, calcium, magnesium, phosphorus, and potassium for bone health, metabolism, and muscle function.",
          },
          {
            label: "Low Glycemic Index:",
            value:
              "Helps regulate blood sugar levels, ideal for individuals with diabetes.",
          },
          {
            label: "Antioxidants:",
            value: "Reduces oxidative stress and inflammation in the body.",
          },
        ],
      },
    ],
    healthBenefits: [
      {
        title: "Health Benefits",
        details: [
          {
            label: "Promotes Digestive Health:",
            value:
              "High fiber supports regular bowel movements and gut health.",
          },
          {
            label: "Helps Manage Blood Sugar:",
            value: "Stabilizes blood sugar levels, preventing spikes.",
          },
          {
            label: "Supports Heart Health:",
            value:
              "Reduces bad cholesterol (LDL) and improves cardiovascular health.",
          },
          {
            label: "Aids in Weight Management:",
            value: "Increases satiety, helping in weight control.",
          },
          {
            label: "Strengthens Bones:",
            value:
              "Rich in calcium and phosphorus, reducing the risk of osteoporosis.",
          },
        ],
      },
    ],
    culinaryUses: [
      {
        title: "Culinary Uses",
        // subTitle: "Kodo millet can be used in a variety of dishes:",
        details: [
          {
            label: "Substitute for Rice:",
            value:
              "Cooked as a rice alternative in pilafs, curries, or stir-fries.",
          },
          {
            label: "Porridges and Upma:",
            value: " Ideal for breakfast porridges or savory dishes like upma.",
          },
          {
            label: "Flour:",
            value: "Used to make gluten-free rotis, pancakes, and bread.",
          },
          {
            label: "Salads and Side Dishes:",
            value: "A nutritious base for salads and vegetable dishes.",
          },
          {
            label: "Snacks:",
            value:
              "Roasted for snacks like energy bars or roasted millet mixes.",
          },
        ],
      },
    ],
    environmentalBenefits: [
      {
        title: "Environmental Benefits",
        details: [
          {
            label: "Drought-Resistant:",
            value:
              "Thrives in arid regions with minimal water, ideal for water-scarce areas.",
          },
          {
            label: "Sustainable Farming:",
            value:
              "Requires fewer resources like water and fertilizers compared to rice or wheat.",
          },
          {
            label: "Soil Health:",
            value:
              "Benefits crop rotation and maintains soil quality with less chemical input.",
          },
        ],
      },
    ],
    culturalImportance: [
      {
        title: "Cultural and Traditional Importance",
        details: [
          {
            label: "",
            value:
              "A staple food in Asia (especially India and China) for centuries, grown in semi-arid regions.",
          },
          {
            label: "",
            value:
              "Celebrated as a sustainable superfood for its resilience to harsh climates and minimal farming inputs.",
          },
        ],
      },
    ],
    glutenFree: [
      {
        title: "Gluten-Free",
        details: [
          {
            label: "",
            value:
              "Naturally gluten-free, suitable for individuals with celiac disease or gluten sensitivity.",
          },
          {
            label: "",
            value: "A great alternative to wheat or rice in various recipes.",
          },
        ],
      },
    ],
    cookingTips: [
      {
        title: "Cooking Tips",
        details: [
          {
            label: "Cooking Ratio:",
            value: "Use 1 part millet to 2.5 parts water.",
          },
          {
            label: "Cooking Time:",
            value: "Typically takes 15–20 minutes to cook.",
          },
          {
            label: "Methods:",
            value: "Can be cooked in a pressure cooker, pot, or rice cooker.",
          },
        ],
      },
    ],
    rightImage:
      "/assets/hindustanpurefoods/product-details/kutki-millet-right.webp",
    bottomImages: [
      {
        img: "/assets/hindustanpurefoods/product-details/bottom-image-1.webp",
      },
      {
        img: "/assets/hindustanpurefoods/product-details/bottom-image-2.webp",
      },
      {
        img: "/assets/hindustanpurefoods/product-details/bottom-image-3.webp",
      },
    ],
  },
];

export const bannerData = [
  {
    subTitle: "From Farm to Plate",
    title: "Taste the Goodness",
    style: "rv-9-banner-slide",
    img: "/assets/hindustanpurefoods/banner/banner1.webp",
  },
  {
    subTitle: "Healthy Choices",
    title: "Pure, Sustainable, and Nutritious",
    style: "rv-9-banner-slide rv-9-banner-slide--2",
    img: "/assets/hindustanpurefoods/banner/banner2.webp",
  },
  {
    subTitle: "Nourish Your Body",
    title: "Discover the Power of Millets",
    style: "rv-9-banner-slide rv-9-banner-slide--3",
    img: "/assets/hindustanpurefoods/banner/banner3.webp",
  },
];
export const categoryData = [
  {
    id: 1,
    mainImg: "/assets/hindustanpurefoods/millet-category/kutki-millet.webp",
    category: "Kutki Millet",
    desc: "Kutki millet nutrient-rich, sustainable, small-grained millet for healthy diets.",
  },
  {
    id: 2,
    mainImg: "/assets/hindustanpurefoods/millet-category/kudo-millet.webp",
    category: "Kodo Millet",
    desc: "Kodo millet nutritious, sustainable, small-grain millet for healthy living.",
  },
  {
    id: 3,
    mainImg: "/assets/hindustanpurefoods/millet-category/barnyard-millet.webp",
    category: "Barnyard Millet",
    desc: "Barnyard millet hardy, fast-growing, nutritious grain for diverse soil conditions.",
  },
  {
    id: 4,
    mainImg: "/assets/hindustanpurefoods/millet-category/foxtail-millet.webp",
    category: "Foxtail Millet",
    desc: "Foxtail millet ancient, nutritious, versatile, sustainable grain for healthy diets.",
  },
];

export const serviceData = [
  {
    id: 1,
    img: "/assets/img/service-details-13.jpg",
    iconImg: "/assets/hindustanpurefoods/icons/icon3.webp",
    title: "Mission",
    slug: "lawn-renovation",
    desc: "To revolutionize the food industry by offering nutritious, high-quality millet products, promoting sustainable farming practices, supporting farmer livelihoods, and fostering a healthier, environmentally conscious world.",
  },
  {
    id: 2,
    img: "/assets/img/service-details-14.jpg",
    iconImg: "/assets/hindustanpurefoods/icons/icon2.webp",
    title: "Vision",
    slug: "eco-friendly",
    desc: "To be a global leader in millet-based food production, inspiring a healthier lifestyle and fostering a sustainable future by making millets a preferred choice for individuals and communities across the globe.",
  },
  {
    id: 3,
    img: "/assets/img/service-details-15.jpg",
    iconImg: "/assets/hindustanpurefoods/icons/icon1.webp",
    title: "Core Values",
    slug: "free-pick-up",
    desc: "At the heart of our operations, core values drive our commitment to trust, integrity, quality, and sustainability. These principles guide every decision, ensuring impactful solutions for consumers and partners while fostering innovation.",
  },
];

export const testimonialData2 = [
  {
    name: "Rajesh Kumar",
    desc: "“Hindustan Pure Foods’ millet products are fantastic! They are healthy, delicious, and perfect for my family's diet. Highly recommend them for anyone looking to switch to natural, sustainable, and wholesome food options.”",
    thumbImg: "/assets/hindustanpurefoods/about/boy_vectors-1.webp",
  },
  {
    name: "Meena Sharma",
    desc: "“I tried their millet flour, and it’s amazing! It made soft and tasty rotis. A great gluten-free alternative that’s packed with nutrition. Kudos to Hindustan Pure Foods for promoting healthy living!”",
    thumbImg: "/assets/hindustanpurefoods/about/boy_vectors-1.webp",
  },
  {
    name: "Amit Das",
    desc: "“Top-quality millets at affordable prices! I love their variety and freshness. My favorite is the millet porridge mix—quick, nutritious, and tasty. Perfect for busy mornings. Keep up the good work!”",
    thumbImg: "/assets/hindustanpurefoods/about/boy_vectors-1.webp",
  },
  {
    name: "Priya Nair",
    desc: "“Finally, a brand that combines health and taste! Hindustan Pure Foods’ millet products have become a staple in my kitchen. My kids love the millet snacks, and I feel good feeding them healthy food.”",
    thumbImg: "/assets/hindustanpurefoods/about/girl_vectors-1.webp",
  },
  {
    name: "Vivek Gupta",
    desc: "“Excellent millet products with great packaging and freshness. Switching to millets has improved my family’s health, and Hindustan Pure Foods made the transition easy and delightful. Highly trustworthy brand for health-conscious consumers!”",
    thumbImg: "/assets/hindustanpurefoods/about/boy_vectors-2.webp",
  },
];

export const serviceInfoData = [
  {
    id: 1,
    title: "B2B Solutions",
    description:
      "We collaborate with businesses to provide bulk supply of Little Millets, tailored for wholesalers, distributors, and food processors with cost-effective pricing.",
    slug: "b2b-solutions",
    icon: Icon,
    img: "/assets/hindustanpurefoods/about/b2b.webp",
  },
  {
    id: 2,
    title: "B2C Solutions",
    description:
      "Our premium Little Millets are available directly to consumers, providing healthy, high-quality grains for individual use.",
    slug: "b2c-solutions",
    icon: Icon2,
    img: "/assets/hindustanpurefoods/about/b2c.webp",
  },
  {
    id: 3,
    title: "Private Labeling",
    description:
      "We offer private labeling services for businesses, allowing you to brand our Little Millets with your unique identity, ensuring a premium product for your customers.",
    slug: "private-labeling",
    icon: Icon3,
    img: "/assets/hindustanpurefoods/about/labeling.webp",
  },
  {
    id: 4,
    title: "Contract Manufacturing",
    description:
      "We provide contract manufacturing services, producing Little Millets under your brand specifications, with strict quality control and timely delivery.",
    slug: "contract-manufacturing",
    icon: Icon4,
    img: "/assets/hindustanpurefoods/about/manufacturing.webp",
  },
  {
    id: 5,
    title: "white Labeling",
    description:
      "We specialize in eco-friendly farming methods, ensuring that our millets are cultivated without the use of harmful chemicals. We are dedicated to upholding environmental responsibility in every step of the process.",
    slug: "sustainability-practices",
    icon: Icon,
    img: "/assets/hindustanpurefoods/about/white-labeling.webp",
  },
];

export const sliderData = [
  {
    id: 1,
    mainImg: "/assets/hindustanpurefoods/home-slider/slide-image-1.webp",
    desc: "Rubbish Removal",
    title: "Kutki Millet",
  },
  {
    id: 2,
    mainImg: "/assets/hindustanpurefoods/home-slider/slide-image-2.webp",
    desc: "Rubbish Removal",
    title: "Kodo Millet ",
  },
  {
    id: 3,
    mainImg: "/assets/hindustanpurefoods/home-slider/slide-image-3.webp",
    desc: "Rubbish Removal",
    title: "Barnyard Millet",
  },
  {
    id: 4,
    mainImg: "/assets/hindustanpurefoods/home-slider/slide-image-4.webp",
    desc: "Rubbish Removal",
    title: "Foxtail Millet",
  },
];
